// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-hobby-project-js": () => import("./../src/pages/hobby-project.js" /* webpackChunkName: "component---src-pages-hobby-project-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-tsx": () => import("./../src/pages/page-2.tsx" /* webpackChunkName: "component---src-pages-page-2-tsx" */),
  "component---src-pages-portofolio-project-js": () => import("./../src/pages/portofolio-project.js" /* webpackChunkName: "component---src-pages-portofolio-project-js" */)
}

